// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Card, Typography } from "@mg/dali/src";
// eslint-disable-next-line import/named
import { createRoute, useNavigate } from "@tanstack/react-router";

import { integrationSettingsRoute } from "./routes/integrationSettingsRoute";
import { knowledgeSettingRoute } from "./routes/knowledgeSettingRoute";

import { authLayoutRoute } from "../auth-layout/route";

export const settingsRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: "settings",

  component: Settings,
});

function Settings() {
  const navigate = useNavigate({ from: settingsRoute.to });
  return (
    <article className="grid gap-6 overflow-auto px-10 py-6">
      <header className="flex items-center justify-between">
        <Typography as="h1" size="2xl" weight="bold">
          Settings
        </Typography>
      </header>

      <Card onClick={() => navigate({ to: knowledgeSettingRoute.to })}>
        <div className="grid gap-1 p-2">
          <Typography weight="bold">Knowledge Settings</Typography>
          <Typography size="sm" className="text-gray-500">
            Manage brand guidelines, reference files, and templates for AI
            reviews.
          </Typography>
        </div>
      </Card>

      <Card onClick={() => navigate({ to: integrationSettingsRoute.to })}>
        <div className="grid gap-1 p-2">
          <Typography weight="bold">Integration Settings</Typography>
          <Typography size="sm" className="text-gray-500">
            Configure trigger events, comment behavior, and design review rules
            for Wrike and Asana integrations.
          </Typography>
        </div>
      </Card>
    </article>
  );
}
